import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"color":_vm.color,"timeout":_vm.timeout,"id":'snackbar--' + _vm.id},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attr = ref.attr;
return [_c(VBtn,_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.closeMessage()}}},'v-btn',attr,false),[_c(VIcon,[_vm._v("mdi-close-circle")])],1)]}}]),model:{value:(_vm.shown),callback:function ($$v) {_vm.shown=$$v},expression:"shown"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }